import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { LandingPageComponent } from './landing-page/landing-page.component';
import { AboutPageComponent } from './about-page/about-page.component';
import { ServicesPageComponent } from './services-page/services-page.component';
import { NotFoundComponent } from './not-found/not-found.component';
import { ClientsPageComponent } from './clients-page/clients-page.component';
import { BlogsPageComponent } from './blogs-page/blogs-page.component';
import { ServiceDataAnalyticsComponent } from './services-page/service-subpages/service-data-analytics/service-data-analytics.component';
import { ServiceWebDevelopmentComponent } from './services-page/service-subpages/service-web-development/service-web-development.component';
import { ServiceIncreaseTrafficComponent } from './services-page/service-subpages/service-increase-traffic/service-increase-traffic.component';
import { ServiceEmailMarketingComponent } from './services-page/service-subpages/service-email-marketing/service-email-marketing.component';
import { ServiceSocialMarketingComponent } from './services-page/service-subpages/service-social-marketing/service-social-marketing.component';
import { ServiceSeoComponent } from './services-page/service-subpages/service-seo/service-seo.component';
import { ServiceGenericPostComponent } from './services-page/service-generic-post/service-generic-post.component';
import { ServiceMarketingStrategiesComponent } from './services-page/service-subpages/service-marketing-strategies/service-marketing-strategies.component';
import { ServiceContentMarketingComponent } from './services-page/service-subpages/service-content-marketing/service-content-marketing.component';
import { AboutProcessComponent } from './about-page/about-process/about-process.component';

const routes: Routes = [
  {path: '', component: LandingPageComponent},
  {path: 'about', component: AboutPageComponent},
  {path: 'process', component: AboutProcessComponent},
  {path: 'clients', component: ClientsPageComponent},
  {path: 'blogs', component: BlogsPageComponent},
  {path: 'services', children: [
    {path: '', component: ServicesPageComponent},
    {path: 'post', component: ServiceGenericPostComponent, children: [
      {path: 'data-analytics', component: ServiceDataAnalyticsComponent},
      {path: 'web-development', component: ServiceWebDevelopmentComponent},
      {path: 'traffic-sales', component: ServiceIncreaseTrafficComponent},
      {path: 'email-marketing', component: ServiceEmailMarketingComponent},
      {path: 'social-marketing', component: ServiceSocialMarketingComponent},
      {path: 'seo', component: ServiceSeoComponent},
      {path: 'marketing-strategies', component: ServiceMarketingStrategiesComponent},
      {path: 'content-marketing', component: ServiceContentMarketingComponent},
    ]}
  ]},
  {path: '**', component: NotFoundComponent}
];

@NgModule({
  imports: [RouterModule.forRoot(routes, {
    // initialNavigation: 'enabled',
    relativeLinkResolution: 'legacy'
})],
  exports: [RouterModule]
})
export class AppRoutingModule { }
